import { render, staticRenderFns } from "./batch-payout-reference-list.vue?vue&type=template&id=38c677bf&scoped=true"
import script from "./batch-payout-reference-list.vue?vue&type=script&lang=js"
export * from "./batch-payout-reference-list.vue?vue&type=script&lang=js"
import style0 from "./batch-payout-reference-list.vue?vue&type=style&index=0&id=38c677bf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c677bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38c677bf')) {
      api.createRecord('38c677bf', component.options)
    } else {
      api.reload('38c677bf', component.options)
    }
    module.hot.accept("./batch-payout-reference-list.vue?vue&type=template&id=38c677bf&scoped=true", function () {
      api.rerender('38c677bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/batch-payout-reference-list.vue"
export default component.exports